import { Type } from "src/utils";

/**
 * 表示一个时间单位枚举。
 * @enum
 * @version 1.0.0
 */
enum DurationUnitType
{
    /**
     * 天
     * @member
     */
     Day = 1,

    /**
     * 月
     * @member
     */
     Month = 2,

    /**
     * 年
     * @member
     */
     Year = 3
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(DurationUnitType,
{
    Day:
    {
        alias: "天",
        description: ""
    },
    Month:
    {
        alias: "月",
        description: ""
    },
    Year:
    {
        alias: "年",
        description: ""
    }
});

export default DurationUnitType;